package com.kinoshazam.screens.rootFlow

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.kinoshazam.config.PlatformConfig.Platform
import com.kinoshazam.config.getPlatformConfig
import com.kinoshazam.uiKit.theme.UiKitTheme

/** Web-only build stamp (drawer / desktop overlay). Hidden on native apps. */
@Composable
fun AppVersionWatermark(
    modifier: Modifier = Modifier,
    onClick: (() -> Unit)? = null,
) {
    val config = remember { getPlatformConfig() }
    if (config.platform != Platform.WEB) return

    Text(
        text = "© Kinoshka · v${config.version}",
        color = UiKitTheme.colors.color_2,
        fontSize = 11.sp,
        textAlign = TextAlign.Center,
        modifier = modifier
            .fillMaxWidth()
            .padding(top = 16.dp, bottom = 8.dp)
            .then(
                if (onClick != null) Modifier.clickable(onClick = onClick) else Modifier
            ),
    )
}
